import { providerLogger } from '@ragu-components/logger';
import { CSRF_TOKEN_HEADER, getRealmId, getStoredCsrfToken } from '@ragu-components/ord-providers';
import { defaultOptions, Upload, DetailedError } from 'tus-js-client';

/**
 * the absolute path is required because of how the tus client lib builds the url for the PATCH request
 * https://github.com/tus/tus-js-client/blob/4ecff1097a1deab7f293fdecb412540c0d80b7b6/lib/upload.js#L1039C1-L1041C2
 */
export const setupTusEndpoint = (): void => {
  defaultOptions.endpoint = `https://${window.location.host}/api/v1/upload/domains/${getRealmId()}/files/`;
};

/**
 * Removes files info from localstorage after file has been successfully uploaded
 * https://github.com/tus/tus-js-client/blob/main/docs/api.md#removefingerprintonsuccess
 */
export const setupTusDefaults = (): void => {
  defaultOptions.removeFingerprintOnSuccess = true;
};

export const setupTusHeaders = (): void => {
  defaultOptions.headers = { [CSRF_TOKEN_HEADER]: getStoredCsrfToken() ?? '' };
};

export const uploadFile = async (
  file: File,
  fileId: string,
  fileType: string,
  onProgress?: (percentage: number) => void
): Promise<void> => {
  setupTusEndpoint();
  setupTusDefaults();
  setupTusHeaders();
  return new Promise((resolve, reject) => {
    providerLogger.debug('File: ', file, 'id: ', fileId, 'type: ', fileType);
    const upload = new Upload(file, {
      metadata: {
        resource: fileType,
        resource_id: fileId,
        filename: file.name,
      },
      onError: (error: Error | DetailedError) => {
        providerLogger.error('Upload failed', error);
        const err: unknown | number = error instanceof DetailedError ? error.originalResponse?.getStatus() : error;
        reject(err);
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        const percentage = (bytesUploaded / bytesTotal) * 100;
        providerLogger.debug(bytesUploaded, bytesTotal, `${percentage.toFixed(2)}%`);
        onProgress?.(percentage);
      },
      onSuccess: () => {
        providerLogger.info('File successfully uploaded');
        resolve();
      },
    });
    upload.start();
  });
};
